
export const getUnlimitedValue = (user) => {
    // First check for stored subscription period
    if (user.subscriptionPeriod) {
      return user.subscriptionPeriod;
    }
    // Fallback logic for existing records

    if (!user.unlimitedUntil) return 'inactive';
    return 'inactive'; // Default to inactive if no subscription period is stored
  };

  export const getUnlimitedColor = (value) => {
    switch (value) {
      case 'lifetime':
        return 'bg-purple-100 text-purple-800 hover:bg-purple-200';
      case 'inactive':
        return 'bg-gray-100 text-gray-800 hover:bg-gray-200';
      case '12':
        return 'bg-green-100 text-green-800 hover:bg-green-200';
      case '6':
        return 'bg-blue-100 text-blue-800 hover:bg-blue-200';
      case '3':
        return 'bg-cyan-100 text-cyan-800 hover:bg-cyan-200';
      default:
        return 'bg-gray-100 text-gray-800 hover:bg-gray-200';
    }
  };
  export const getSubscriptionStatus = (user) => {
    if (user.subscriptionPeriod === 'lifetime') {
      return 'Never expires';
    }
    if (user.unlimitedUntil) {
      const expiryDate = user.unlimitedUntil.toDate();
      const now = new Date();
      if (expiryDate > now) {
        return `Expires: ${formatDate(user.unlimitedUntil)}`;
      }
      return 'Expired';
    }
    return 'No active subscription';
  };
  export const getRoleColor = (role) => {
    switch (role) {
      case 'admin':
        return 'bg-purple-100 text-purple-800 hover:bg-purple-200';
      case 'manager':
        return 'bg-blue-100 text-blue-800 hover:bg-blue-200';
      default:
        return 'bg-gray-100 text-gray-800 hover:bg-gray-200';
    }
  };
  export const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date?.toDate()).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };
  // Format time ago helper
  export const getTimeAgo = (date) => {
    if (!date) return 'Never';
    const seconds = Math.floor((new Date() - date?.toDate()) / 1000);
    let interval = seconds / 31536000;

    if (interval > 1) return Math.floor(interval) + ' years ago';
    interval = seconds / 2592000;
    if (interval > 1) return Math.floor(interval) + ' months ago';
    interval = seconds / 86400;
    if (interval > 1) return Math.floor(interval) + ' days ago';
    interval = seconds / 3600;
    if (interval > 1) return Math.floor(interval) + ' hours ago';
    interval = seconds / 60;
    if (interval > 1) return Math.floor(interval) + ' minutes ago';
    return Math.floor(seconds) + ' seconds ago';
  };


  export const getUnlimitedOptions = (referralSettings) => {
    if (!referralSettings?.rewards) {
      return [{ value: "inactive", label: "Inactive" }];
    }

    // Always start with inactive option
    const options = [{ value: "inactive", label: "Inactive" }];

    // Add all unique duration options from rewards settings
    const uniqueDurations = new Set();
    referralSettings.rewards.forEach(reward => {
      if (!uniqueDurations.has(reward.duration)) {
        uniqueDurations.add(reward.duration);
        if (reward.duration === "lifetime") {
          options.push({ value: "lifetime", label: "Lifetime" });
        } else {
          options.push({
            value: String(reward.duration),
            label: `${reward.duration} Months`
          });
        }
      }
    });

    // Sort options by duration (putting "lifetime" at the end)
    return options.sort((a, b) => {
      if (a.value === "inactive") return -1;
      if (b.value === "inactive") return 1;
      if (a.value === "lifetime") return 1;
      if (b.value === "lifetime") return -1;
      return parseInt(a.value) - parseInt(b.value);
    });
  };

  export function capitalizeWords(str) {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
  
  export function formatCurrency(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }